import * as types from "../../mutation-types";

const mutations = {
  [types.SET_SC_WORK_GROUPS]: (state, payload) => {
    state.sc_work_groups = payload;
  },
  [types.SET_SC_WORK_GROUP]: (state, payload) => {
    state.sc_work_group = payload;
  },
  [types.ADD_SC_WORK_GROUP_ITEM]: (state, payload) => {
    state.sc_work_groups.push(payload);
  },
  [types.UPDATE_SC_WORK_GROUP_ITEM]: (state, payload) => {
    state.sc_work_groups.splice(state.sc_work_groups.indexOf(
      state.sc_work_groups.find(c => c.uuid === payload.uuid)
    ), 1, payload);
  },
  [types.DELETE_SC_WORK_GROUP_ITEM]: (state, payload) => {
    state.sc_work_groups.splice(state.sc_work_groups.indexOf(
      state.sc_work_groups.find(c => c.uuid === payload.uuid)
    ), 1);
  },
  [types.SET_SC_WORK_GROUP_FILTERS]: (state, payload) => {
    state.sc_work_group_filters = payload;
  },
}

export default mutations;
